import { render, staticRenderFns } from "./ViewOnlyWarning.vue?vue&type=template&id=199d8d60&"
import script from "./ViewOnlyWarning.vue?vue&type=script&lang=js&"
export * from "./ViewOnlyWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports